import { cached } from '@glimmer/tracking';
import BaseController from 'uplisting-frontend/pods/base/controller';

export interface IProtectionTab {
  id: string;
  route: string;
  labelKey: string;
}

const DEPOSITS_AND_GUEST_ID: IProtectionTab = {
  id: 'deposits-and-guest-id',
  route: 'protection.overview',
  labelKey: 'nav_links.protection.index',
};

const DISPUTES: IProtectionTab = {
  id: 'disputes',
  route: 'protection.disputes',
  labelKey: 'nav_links.protection.disputes',
};

const SETTINGS: IProtectionTab = {
  id: 'settings',
  route: 'protection.settings',
  labelKey: 'nav_links.protection.settings',
};

export default class ProtectionController extends BaseController {
  @cached
  get navTabs(): IProtectionTab[] {
    const tabs: IProtectionTab[] = [];

    if (this.isDepositsAndGuestIdPermitted) {
      tabs.push(DEPOSITS_AND_GUEST_ID);
    }

    if (this.isDisputesPermitted) {
      tabs.push(DISPUTES);
    }

    if (this.isSettingsPermitted) {
      tabs.push(SETTINGS);
    }

    return tabs;
  }

  @cached
  get captionKey(): string {
    if (this.currentRouteName.startsWith(SETTINGS.route)) {
      return 'protection_settings.caption';
    }

    return this.currentRouteName.startsWith(DISPUTES.route)
      ? 'protection_disputes.caption'
      : 'protection_index.caption';
  }

  @cached
  get isDepositsAndGuestIdPermitted(): boolean {
    const { currentUser } = this;

    return (
      currentUser.hasAccessTo('dashboard.index') ||
      currentUser.hasAccessTo('advanced_report_configurations.index')
    );
  }

  @cached
  get isDisputesPermitted(): boolean {
    return this.currentUser.hasAccessTo('disputes.index');
  }

  @cached
  get isSettingsPermitted(): boolean {
    return this.currentUser.hasAccessTo('automate.identity');
  }
}
